import DistributorContent from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Distributor/DistributorContent'
import DistributorEmpty from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Distributor/DistributorEmpty'
import useDistributor from '@/containers/SubscriptionFormPageNew/Components/Distributor/useDistributor'
import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'
const Distributor = () => {
  const { noDistributorData, isCityEligibilityLoading, t, country } = useDistributor()

  if (country !== 'fr') return null

  if (isCityEligibilityLoading) {
    return <SDLoader text={t('subscriptionForm:distributor.loading_city_eligibility')} />
  }

  if (noDistributorData) return <DistributorEmpty />

  return <DistributorContent />
}

export default Distributor
